import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, UserPlus, Trash2 } from "lucide-react";
import { adminApi } from "../../lib/api";

const inputCls = "w-full px-3 py-2 text-sm bg-[#0A0A0A] border border-[#262626] focus:outline-none focus:border-blood";

export function TempCoverPanel({ roleId, showDateId, onDone }) {
  const [covers, setCovers] = useState([]);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);

  const loadCovers = () => adminApi.get("/admin/temp-covers").then(({ data }) => setCovers(data.items || []));
  useEffect(() => { loadCovers(); }, []);

  const add = async (body) => {
    setBusy(true);
    try {
      await adminApi.post("/admin/roster/assign-temp", { role_id: roleId, show_date_id: showDateId, ...body });
      toast.success("Temporary cover added to the roster");
      onDone();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Couldn't add cover.");
    } finally { setBusy(false); }
  };
  const remove = async (c) => {
    if (!window.confirm(`Delete ${c.full_name} from the cover list? They'll be removed from ${c.nights} roster night(s).`)) return;
    await adminApi.delete(`/admin/temp-covers/${c.id}`);
    toast.success(`${c.full_name} removed`);
    onDone();
  };

  return (
    <div className="mt-4 pt-4 border-t border-[#1a1a1a]" data-testid="temp-cover-panel">
      <p className="text-xs uppercase tracking-wider text-[#22D3EE] mb-1">Temporary cover</p>
      <p className="text-[11px] text-[#6B6862] mb-3">For someone covering who isn't in the cast. No email or contract is sent.</p>
      {covers.length > 0 && (
        <div className="space-y-1.5 mb-3 max-h-40 overflow-y-auto" data-testid="temp-cover-list">
          {covers.map((c) => (
            <div key={c.id} className="flex items-center justify-between gap-2 px-3 py-2 border border-[#262626] hover:border-[#22D3EE]/50">
              <button onClick={() => add({ temp_id: c.id })} disabled={busy} data-testid={`temp-cover-pick-${c.id}`} className="flex-1 text-left text-sm">
                {c.full_name}{c.phone && <span className="text-[11px] text-[#6B6862] ml-2">{c.phone}</span>}
                <span className="text-[10px] text-[#6B6862] ml-2 font-mono">{c.nights} night{c.nights === 1 ? "" : "s"}</span>
              </button>
              <button onClick={() => remove(c)} data-testid={`temp-cover-delete-${c.id}`} className="text-[#6B6862] hover:text-blood"><Trash2 size={13} /></button>
            </div>
          ))}
        </div>
      )}
      <div className="grid grid-cols-[1fr_140px_auto] gap-2">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Cover's name" data-testid="temp-cover-name" className={inputCls} />
        <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="Phone (optional)" data-testid="temp-cover-phone" className={inputCls} />
        <button onClick={() => add({ full_name: name, phone })} disabled={busy || !name.trim()} data-testid="temp-cover-add"
          className="inline-flex items-center gap-1.5 px-3 py-2 text-xs uppercase tracking-wider bg-[#155E75] text-[#CFFAFE] hover:bg-[#0E7490] disabled:opacity-40">
          {busy ? <Loader2 size={13} className="animate-spin" /> : <UserPlus size={13} />} Add
        </button>
      </div>
    </div>
  );
}
